import { maybeGetDocument } from './globals';
export function readCookie(name) {
    const cookieValue = getCookieByName(name);
    if (cookieValue) {
        return cookieValue.split('=')[1];
    }
    return '';
}
function loadCookies() {
    const documentObj = maybeGetDocument();
    if (documentObj && documentObj.cookie) {
        return decodeURIComponent(documentObj.cookie).split(';');
    }
    return [];
}
function getCookieByName(name) {
    return loadCookies().filter((cookie) => name === cookie.split('=')[0].trim())[0];
}
//# sourceMappingURL=cookies.js.map